import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = false

const bubbleExportVisible = createSlice({
  name: 'bubbleExportVisible',
  initialState,
  reducers: {
    togglebubbleExport(_state, action: PayloadAction<{ loading: boolean }>) {
      return action.payload.loading
    },
  },
})

export const { togglebubbleExport } = bubbleExportVisible.actions

export default bubbleExportVisible.reducer
